export default function Contact() {
  return <h2>Contacts Page</h2>;
}
